import { DynamicContentType } from '@bm-js/atlascloud-shared'
import { useDraggable } from '@dnd-kit/core'
import { PropsWithChildren } from 'react'
import { EditorDroppbleData } from './EditorDroppable'

export interface DraggableData {
  content: DynamicContentType<unknown>
  source: 'sidebar' | EditorDroppbleData
}

type Props = {
  id: string
  data: DraggableData
}

const Draggable = ({ id, children, data }: PropsWithChildren<Props>) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data,
  })

  return (
    <div {...attributes} {...listeners} ref={setNodeRef}>
      {children}
    </div>
  )
}

export default Draggable
